import { render, staticRenderFns } from "./AddTutorialVideo.vue?vue&type=template&id=374958e4"
import script from "./AddTutorialVideo.vue?vue&type=script&lang=js"
export * from "./AddTutorialVideo.vue?vue&type=script&lang=js"
import style0 from "./AddTutorialVideo.vue?vue&type=style&index=0&id=374958e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports